/**
 * Amplitude autocaptures element interactions only inside elements marked with one of these
 * scopes (see `AmplitudeWebTransport`), which keeps the click volume of trading screens out of
 * the event quota. Add a scope here and spread {@link analyticsScopeAttributes} onto its root.
 */
export const ANALYTICS_SCOPE_ATTRIBUTE = 'data-analytics-scope';

export const AnalyticsScope = {
    subscriptionSetup: 'subscription-setup',
} as const;
export type AnalyticsScope = (typeof AnalyticsScope)[keyof typeof AnalyticsScope];

export const analyticsScopeAttributes = (
    scope: AnalyticsScope,
): Record<typeof ANALYTICS_SCOPE_ATTRIBUTE, AnalyticsScope> => ({
    [ANALYTICS_SCOPE_ATTRIBUTE]: scope,
});
